export const POP_UP_WIDTH = 377;
export const POP_UP_HEIGHT = 531;
export const CARD_WIDTH = 20;
export const CARD_HEIGHT = 26;
export const CARD_MARGIN = 0.78125;

/*******************
  STORAGE CONSTANTS
 ******************/
export const AUTH_TOKEN = 'authToken';
export const SLUG_ABOUT_US = 'about-us';
export const SLUG_BECOME_A_TUTOR = 'become-a-tutor';

/*******************
      EVENTS
 ******************/
export const SCREEN_SIZE_WAS_CHANGED = 'screenSizeWasChanged';
export const CLIENT_WIDTH_WAS_CHANGED = 'clientWidthWasChanged';
export const HEADER_MENU_OPENED = 'headerMenuOpened';
export const HEADER_MENU_CLOSED = 'headerMenuClosed';
export const LANGUAGE_WAS_CHANGED = 'languageWasChanged';
export const USER_HAS_LOGGED_IN = 'userHasLoggedIn';
export const USER_HAS_LOGGED_OUT = 'userHasLoggedOut';
export const PRODUCT_HAS_ADDED_TO_WISHLIST = 'productHasAddedToWishList';
export const PRODUCT_HAS_REMOVED_FROM_WISHLIST = 'productHasAddedToWishList';
export const POPUP_VISIBILITY_HAS_CHANGED = 'popupVisibilityHasChanged';
export const CART_HAS_CHANGED = 'cartHasChanged';
export const REMOVE_FROM_BASKET = 'removeFromBasket';
export const EXPIRED_AUTH_TOKEN = 'expiredAuthToken';





// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/app.constants.ts